/*!
 *  - share.js
 * @generated Fri Feb 28 2020 12:37:07 GMT+0900 (東京 (標準時))
 */
'use strict';

(function ($, DIC) {

	var share = function share() {
		var shareUrl = document.URL;
		var sharePagetitle = document.title;

		// fb
		if ($('.js-share-btn-facebook').length) {
			$('.js-share-btn-facebook .fb-share-button').attr('data-href', shareUrl);
		}
		if ($('.js-news-share-btn-facebook').length) {
			$('.js-news-share-btn-facebook .fb-share-button').attr('data-href', shareUrl);
		}

		var fbEl = document.createElement("script");
		if (!(location.pathname.split('/')[1] === 'ja')) {
			fbEl.src = "https://connect.facebook.net/en_US/sdk.js#xfbml=1&version=v3.2";
		} else {
			fbEl.src = "https://connect.facebook.net/ja_JP/sdk.js#xfbml=1&version=v3.2";
		}
		document.body.appendChild(fbEl);

		// line
		if ($('.js-share-btn-line').length) {
			$('.js-share-btn-line .line-it-button').attr('data-url', shareUrl);
		}
		if ($('.js-news-share-btn-line').length) {
			$('.js-news-share-btn-line .line-it-button').attr('data-url', shareUrl);
		}
		var lineEl = document.createElement("script");
		lineEl.src = "https://d.line-scdn.net/r/web/social-plugin/js/thirdparty/loader.min.js";
		document.body.appendChild(lineEl);

		// mail
		if ($('.js-share-btn-mail').length) {
			$('.js-share-btn-mail a').attr('href', 'mailto:?subject=' + sharePagetitle + '&body=' + shareUrl);
		}
		if ($('.js-news-share-btn-mail').length) {
			$('.js-news-share-btn-mail a').attr('href', 'mailto:?subject=' + sharePagetitle + '&body=' + shareUrl);
		}
		// weibo
		if ($('.js-share-btn-weibo').length) {
			$('.js-share-btn-weibo a').attr('href', 'http://service.weibo.com/share/share.php?url=' + shareUrl + '&appkey=480593611&title=' + sharePagetitle + '&pic=https://www.dic-global.com/common/images/ogp.png');
		}
		if ($('.js-news-share-btn-weibo').length) {
			$('.js-news-share-btn-weibo a').attr('href', 'http://service.weibo.com/share/share.php?url=' + shareUrl + '&appkey=480593611&title=' + sharePagetitle + '&pic=https://www.dic-global.com/common/images/ogp.png');
		}
		// cmsで書き出されたハッシュタグ取得、描画
		if ($('.rt_cf_n_hashtag').length) {
			var hash = $('.rt_cf_n_hashtag').attr('data-cf_n_hashtag').replace('#', '').replace(/#/g, ',');
			// twitter
			$('.js-share-btn-twitter .twitter-share-button').attr('href', 'https://twitter.com/share?ref_src=twsrc%5Etfw&hashtags=' + hash);
			$('.js-news-share-btn-twitter .twitter-share-button').attr('href', 'https://twitter.com/share?ref_src=twsrc%5Etfw&hashtags=' + hash);
		}
		// QR code
		if ($('.js-share-btn-QR').length) {
			$('.js-share-btn-QR .mod-share-QR').magnificPopup({
				disableOn: false,
				type: 'inline',
				mainClass: 'mfp-with-zoom',
				zoom: {
					enabled: true,
					duration: 300,
					easing: 'ease-in-out'
				},
				removalDelay: 160,
				preloader: false,
				fixedContentPos: false
			});
			$('.js-share-btn-QR .mod-share-QR-content-in').qrcode(location.href);
		}
	};

	share();
})(window.jQuery, window.DIC);